export default __webpack_public_path__ + "static/media/ladder_left.413a27e6.png";